import React from "react";
import {
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter,
} from "./ui/dialog";
import { Button } from "./ui/button";
import { CreditCard } from "lucide-react";

export const ConfirmDialog = ({
  open, onOpenChange, title, description, params = {}, costEur, loading,
  onConfirm, confirmLabel = "Conferma e procedi", cancelLabel = "Annulla",
}) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-testid="confirm-dialog" className="sm:max-w-md rounded-xl bg-surface">
        <DialogHeader>
          <DialogTitle className="text-lg font-semibold text-text-primary tracking-tight">{title}</DialogTitle>
          {description && (
            <DialogDescription className="text-sm text-text-secondary leading-relaxed">
              {description}
            </DialogDescription>
          )}
        </DialogHeader>

        <div className="space-y-3 py-2">
          {Object.keys(params).length > 0 && (
            <div className="bg-subtle rounded-md p-4 border border-border">
              <div className="text-[11px] font-medium uppercase tracking-widest text-text-muted mb-2">
                Parametri richiesta
              </div>
              <dl className="space-y-1.5">
                {Object.entries(params).filter(([_, v]) => v !== "" && v !== null && v !== undefined).map(([k, v]) => (
                  <div key={k} className="flex justify-between gap-4 text-sm">
                    <dt className="text-text-secondary">{k}</dt>
                    <dd className="text-text-primary font-medium truncate font-mono text-xs">{String(v)}</dd>
                  </div>
                ))}
              </dl>
            </div>
          )}
          {typeof costEur === "number" && (
            <div className="flex justify-between items-center px-1 pt-1">
              <span className="text-sm text-text-secondary flex items-center gap-1.5">
                <CreditCard size={13} /> Costo stimato
              </span>
              <span className="text-sm font-semibold text-text-primary tabular-nums" data-testid="confirm-cost">
                € {costEur.toFixed(2)}
              </span>
            </div>
          )}
        </div>

        <DialogFooter className="gap-2 sm:gap-2">
          <Button
            type="button"
            variant="outline"
            onClick={() => onOpenChange(false)}
            disabled={loading}
            data-testid="confirm-cancel-button"
            className="rounded-md border-border"
          >
            {cancelLabel}
          </Button>
          <Button
            type="button"
            onClick={onConfirm}
            disabled={loading}
            data-testid="confirm-submit-button"
            className="rounded-md bg-accent hover:bg-accent-strong text-white"
          >
            {loading ? "Elaborazione…" : confirmLabel}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
